import { Card, Col, Row, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import MathUtils from "../../../../common/utils/MathUtils";
import { useTranslation } from "react-i18next";
import calendarIcon from '../../../../assets/icons/CONTENT-ICON-light.png';
import megafono from '../../../../assets/megafono.png';
import estrella from '../../../../assets/estrella-calendario.png';
import insignia from '../../../../assets/insignia.png';

const cardBody = {
    backgroundColor: 'white',
    borderRadius: '16px',
    height: 88,
    padding: '10px 14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

const kpiLabel = {
    fontSize: 11,
    color: '#9F9F9F',
    fontWeight: 500,
    lineHeight: 1.2,
    marginTop: 2,
};

export const BlockContentKpis = (props: {kpis: any}) => {

    const { t } = useTranslation();

    return (
        <>
            <Row gutter={16} style={{ marginBottom: 8 }}>
                <Col span={5}>
                    <Card bodyStyle={cardBody}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <img src={calendarIcon} style={{ height: 40, borderRadius: 12 }}/>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <span style={{ fontSize: 28, fontWeight: 700, lineHeight: 1 }}>
                                    {props.kpis?.totalPosts}
                                </span>
                                <span style={kpiLabel}>
                                    {t('contents.page.global.cards.totalPosts')}
                                    <Tooltip title={t('contents.page.global.cards.totalPostsTooltip')}>
                                        <InfoCircleOutlined style={{ marginLeft: 4, fontSize: 11 }} />
                                    </Tooltip>
                                </span>
                            </div>
                        </div>
                    </Card>
                </Col>
                <Col span={9}>
                    <Card bodyStyle={cardBody}>
                        <div style={{ display: 'flex', justifyContent: 'space-around', width: '100%', alignItems: 'center' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 24, fontWeight: 700, lineHeight: 1 }}>
                                    {props.kpis?.totalNews}
                                    <img src={megafono} style={{ height: 20 }} />
                                </span>
                                <span style={kpiLabel}>{t('contents.page.global.cards.news')}</span>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 24, fontWeight: 700, lineHeight: 1 }}>
                                    {props.kpis?.totalEvents}
                                    <img src={estrella} style={{ height: 20 }} />
                                </span>
                                <span style={kpiLabel}>{t('contents.page.global.cards.events')}</span>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 24, fontWeight: 700, lineHeight: 1 }}>
                                    {props.kpis?.totalOffers}
                                    <img src={insignia} style={{ height: 20 }} />
                                </span>
                                <span style={kpiLabel}>{t('contents.page.global.cards.offers')}</span>
                            </div>
                        </div>
                    </Card>
                </Col>
                <Col span={5}>
                    <Card bodyStyle={cardBody}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <span style={{ fontSize: 28, fontWeight: 700, lineHeight: 1 }}>
                                {props.kpis && props.kpis?.impressions === null ? '-' : MathUtils.round(props.kpis?.impressions, 1)}
                            </span>
                            <span style={kpiLabel}>
                                {t('contents.page.global.cards.impressions')}
                                <Tooltip title={t('contents.page.global.cards.impressionsTooltip')}>
                                    <InfoCircleOutlined style={{ marginLeft: 4, fontSize: 11 }} />
                                </Tooltip>
                            </span>
                        </div>
                    </Card>
                </Col>
                <Col span={5}>
                    <Card bodyStyle={cardBody}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <span style={{ fontSize: 28, fontWeight: 700, lineHeight: 1, display: 'inline-flex', alignItems: 'baseline', gap: 4 }}>
                                {props.kpis && props.kpis?.postFrequency === null ? '-' : MathUtils.round(props.kpis?.postFrequency, 2)}
                                <small style={{ fontSize: 12, fontWeight: 500, color: '#9F9F9F' }}>{t('contents.page.global.cards.days')}</small>
                            </span>
                            <span style={kpiLabel}>
                                {t('contents.page.global.cards.postFrequency')}
                                <Tooltip title={t('contents.page.global.cards.postFrequencyTooltip')}>
                                    <InfoCircleOutlined style={{ marginLeft: 4, fontSize: 11 }} />
                                </Tooltip>
                            </span>
                        </div>
                    </Card>
                </Col>
            </Row>
        </>
    )
}
